import React, { useState, useEffect, useMemo } from 'react';

function TypingEffect({ htmlContent, speed = 0, startDelay = 0 }) {
  const [displayedContent, setDisplayedContent] = useState('');
  const [unitIndex, setUnitIndex] = useState(0);

  const processedUnits = useMemo(() => {
    const units = [];
    const regex = /(<[^>]+>)|([^<]+)/g;
    let match;

    while ((match = regex.exec(htmlContent)) !== null) {
      if (match[1]) {
        units.push({ type: 'tag', value: match[1] });
      } else if (match[2]) {
        for (const char of match[2]) {
          units.push({ type: 'char', value: char });
        }
      }
    }
    return units;
  }, [htmlContent]);

  useEffect(() => {
    setDisplayedContent('');
    setUnitIndex(0);
  }, [htmlContent]);

  useEffect(() => {
    if (!processedUnits || processedUnits.length === 0) return;

    const initialDelayTimer = setTimeout(() => {
      if (unitIndex < processedUnits.length) {
        const currentUnit = processedUnits[unitIndex];

        const timer = setTimeout(() => {
          setDisplayedContent((prev) => prev + currentUnit.value);
          setUnitIndex((prev) => prev + 1);
        }, speed);
        return () => clearTimeout(timer);
      }
    }, startDelay);

    return () => clearTimeout(initialDelayTimer);
  }, [processedUnits, unitIndex, speed, startDelay]);

  return <span dangerouslySetInnerHTML={{ __html: displayedContent }} />;
}

export default TypingEffect;